export default function artists() {

  $('.artists-list').slick({
    centerMode: true,
    slidesToShow: 5,
    centerPadding: '0px',
    prevArrow: '<i class="slick-nav-prev fal fa-chevron-left"></i>',
    nextArrow: '<i class="slick-nav-next fal fa-chevron-right"></i>',
    swipe: false,
    touchMove: false
  });
  
}